import { assignColorsToShardBlocks } from './colors'
import { Shard } from '../lib/types'

function cloneShard(shape: Shard): Shard {
  return {
    blocks: shape.blocks.map((b) => ({ ...b })),
  }
}

const shapes = [
  {
    blocks: gridToBlockList([
      [0, 0, 0],
      [1, 1, 0],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [0, 1, 0],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 0],
      [1, 1, 1],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 0],
      [1, 1, 0],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [1, 1, 1],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 0],
      [1, 1, 1],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 0],
      [0, 1, 1],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 0],
      [1, 1, 0],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 0],
      [1, 1, 1],
      [1, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [1, 1, 0],
      [1, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 0, 0],
      [1, 1, 0],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 1],
      [1, 1, 0],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 0],
      [0, 1, 1],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [1, 1, 1],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 0],
      [1, 1, 1],
      [1, 0, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 1],
      [0, 0, 1],
      [0, 1, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 0],
      [0, 0, 0],
      [0, 1, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 1],
      [1, 1, 0],
      [1, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 1],
      [0, 1, 1],
      [1, 1, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 1],
      [1, 0, 1],
      [1, 1, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 0, 1],
      [1, 0, 1],
      [0, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 0],
      [1, 0, 1],
      [0, 1, 1],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 1],
      [1, 0, 1],
      [1, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 1],
      [1, 1, 1],
      [1, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 1, 1],
      [1, 0, 0],
      [1, 0, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [0, 0, 1],
      [0, 0, 1],
      [1, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 1, 0],
      [0, 1, 1],
      [0, 1, 0],
    ]),
  },
  {
    blocks: gridToBlockList([
      [1, 0, 0],
      [1, 1, 1],
      [0, 1, 0],
    ]),
  },
]
const allShardShapes = shapes.map((shape) => ({
  ...shape,
  blocks: shape.blocks.map((block) => ({
    ...block,
    color: { r: 255, g: 0, b: 0, name: '' },
  })),
}))

export function getRandomShard(): Shard {
  const base = allShardShapes[Math.floor(Math.random() * allShardShapes.length)]!
  const shard = cloneShard(base)
  assignColorsToShardBlocks(shard)
  return shard
}

export function getPseudoRandomShardList(count: number): Shard[] {
  const shards = [...allShardShapes].sort(() => Math.random() - 0.5)
  const results: Shard[] = []
  while (results.length < count) {
    const shard = shards[results.length % shards.length]!
    assignColorsToShardBlocks(shard)
    results.push(shard)
  }
  return results
}

function gridToBlockList([[x0y0, x1y0, x2y0], [x0y1, x1y1, x2y1], [x0y2, x1y2, x2y2]]: [
  [1 | 0, 1 | 0, 1 | 0],
  [1 | 0, 1 | 0, 1 | 0],
  [1 | 0, 1 | 0, 1 | 0],
]): { x: number; y: number }[] {
  const blocks: { x: number; y: number }[] = []
  if (x0y0 === 1) {
    blocks.push({ x: 0, y: 0 })
  }
  if (x1y0 === 1) {
    blocks.push({ x: 1, y: 0 })
  }
  if (x2y0 === 1) {
    blocks.push({ x: 2, y: 0 })
  }
  if (x0y1 === 1) {
    blocks.push({ x: 0, y: 1 })
  }
  if (x1y1 === 1) {
    blocks.push({ x: 1, y: 1 })
  }
  if (x2y1 === 1) {
    blocks.push({ x: 2, y: 1 })
  }
  if (x0y2 === 1) {
    blocks.push({ x: 0, y: 2 })
  }
  if (x1y2 === 1) {
    blocks.push({ x: 1, y: 2 })
  }
  if (x2y2 === 1) {
    blocks.push({ x: 2, y: 2 })
  }
  return blocks
}
